/**
 * Removes the hash fragment from URL without triggering a page reload.
 *
 * @description
 * This function uses the History API directly instead of Vue Router to modify the URL.
 * This approach prevents interference with redirections initiated from within
 * interactive components like modals or drawers (e.g., Duplicate link inside the Listing Details).
 */
export function cleanHashWithoutTriggeringRouterRedirection() {
  window.history.replaceState(
    null,
    document.title,
    window.location.pathname + window.location.search,
  )
}
